<template>
    <div >          
        <div style=" display:flex; width:100%; background:#f8f8f9;line-height:35px;height:37px; margin-top:-5px; border-left:3px solid #409eff">
            <div style="min-width:1100px;display:flex;">
                <div style="margin-right:20px;font-size:14px;margin-left:5px;color:#F56C6C;font-weight:600; line-height:30px;height:30px;margin-top:8px">提示：只引用审核的订单</div>
                <span style=" margin-left:20px;font-size:12px;margin-top:5px">字段查询</span>
                
                <div style="line-height:35px;height:35px"> 
                    <el-select v-model="selparam" size="small" placeholder="请选择列名" filterable style="width:150px;margin-left:5px; " >
                        <span v-for="item in tabArr" :key='item.key'>
                            <el-option :label="item.title" :value="item.key" v-if="item.thide=='N' "></el-option>
                        </span>
                    </el-select>
                    <el-input   v-model="txtparam" @keyup.enter.native="qryTabData" size="small" style="width:320px; height:30px;margin-top:5px ">
                        <el-select v-model="oper" slot="prepend"   style="width:100px; " >
                            <span v-for="item in operArr" :key='item.IDSEQ'>
                                <el-option :label="item.CNAME" :value="item.SUBNO"></el-option>
                            </span>
                        </el-select>
                        <el-button size="small" slot="append" icon="el-icon-search" @click="qryTabData" ></el-button>
                    </el-input> 
                </div>
                <el-button type="primary" size="mini" icon="iconfont icon-yiqueren-xianxing" @click="selSure" style=" height:35px;margin-top:3px;margin-left:20px;">确定选择</el-button> 
            </div>
        </div> 
        <el-table  :data="tabData" 
            border                            
            disabled-hover
            class="custom-table-border"
            style="overflow:auto;margin-top:1px;"
            size="small"
            v-loading="v_loading"
            element-loading-text="加载中"
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(255, 251, 255, 0.8)"
            :height="300" 
            :row-key="getRowKey"  
            ref="tabref" 
            @row-click="rowClick"
            @row-dblclick="selSure"
            highlight-current-row>
            <el-table-column label="序号" type="index" width="55"></el-table-column>
            <el-table-column  v-for="(item,index ) in tabArr.filter(item=>item.thide=='N')" :key="index"
                :prop="item.key"
                :label="item.title"
                show-overflow-tooltip
                :align="item.align"                                  
                :sortable="false"
                :min-width="item.width">
                <template slot-scope="scope">
                    <el-checkbox v-if="item.edcss=='checkbox'" true-label="Y" disabled false-label="N" v-model="scope.row[item.key]" style="width:100%"> &nbsp;</el-checkbox> 
                    <div v-else  >{{scope.row[item.key]}}</div>
                </template> 
            </el-table-column> 
        </el-table>  
        <div style="margin-top: 3px; overflow: hidden;display:flex;">
            <div style="float: left;">
                <Page :total="dataCount" :page-size="rowSize" show-total :current="current" @on-change="changePage"></Page>
            </div>
            <div style="color:#606266;margin:7px 10px;font-size:12px;width:35px;">每页</div>
            <el-select v-model="rowSize" size="small" style="width:80px;"  @change="initPage">
                <el-option 
                    v-for="item in pageList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
            </el-select>

            <div style="color:#606266;margin:7px 10px;margin-left:80px;font-size:12px;width:30px;">跳至</div>
            <el-input v-enter-number size="small" v-model="goPage" style="width:50px;"></el-input> 
            <span style="color:#606266;margin:7px 5px;font-size:12px;">页</span>

            <el-button @click="goNext" size="small" type="primary" style="width:50px;margin-left:15px;height:32px;">GO</el-button>
        </div> 

        <el-table  :data="dtlData" 
            border                            
            size="small"
            ref="refdtl"
            :height="tabHeight" 
            class="custom-table-border"
            v-loading="v_loading2"
            element-loading-text="加载中"
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(255, 251, 255, 0.8)"
            highlight-current-row
            @row-click="perClick" > 
            <el-table-column 
                prop="SEL"
                label="选择"
                fixed="left"
                align="center"  >
                <template  slot-scope="scope" >
                    <el-checkbox  true-label="Y"  false-label="N" v-model="scope.row.SEL" ></el-checkbox>
                </template>
            </el-table-column> 
 
            <el-table-column    v-for="(item ,index) in dtlCol.filter(item=>item.thide=='N')" :key="index"
                :prop="item.key"
                :label="item.title"
                show-overflow-tooltip
                :align="item.align"                                  
                :sortable="item.sortable=='N'"
                :min-width="item.width">
            </el-table-column> 
                         
        </el-table>
    </div>  
</template>
<script>
 
import { getTabColOrData,getBaseData } from '../../api/user';
import { getDate } from '../../api/Select' 
//局部注册
export default {
 
    data () {
        return {
            drawer:false,
            saleWin:false,
            perFlag:'create',
            dtlRow:{},
            sendVal:'PRD',
            saveFlag:false,
            empWin:false,
            promtWin:false,
            prodWin:false,
            prompt:'',
            stfgCss:'',
            perWin:false,
            stfgColor:'',
            mainRow:{},
            clntWin:false,
            cashArr:[], // 
            listIndex:'-1',
            active:'', //二级菜单选中标志
            operArr:[],
            disabled:false, //新增权限制
            stfgSet:'ALL',
            idseq:'', //菜单主键
            lstseq:'',//菜单主键
            ruleValidate:{},
            formArr:[],
            v_loading:false,
            v_loading2:false,
            tabData:[], //表数据
            allData:[],
            tabArr:[], //表列
            dtlData:[], //明细数据
            dtlCol:[],
            oper:'like',
            comboArr:{},
            txtparam:'',
            selparam:'',
            delArr:[],
            rowIndex:'-1',
            v_url:'xuper_auth/getTableRecMany', //api请求路径
            v_formurl:'xuper_auth/getFormGroup', 
            v_username:this.$cookies.get('v_telno'), //api 请求用户
            
            v_corpid:this.$cookies.get('v_corpid') ,//api 请求密码
            v_admin:this.$cookies.get('v_admin') ,//api 请求密码
            dataCount:0,
            rowSize:50,
            goPage:'',
            notNull:[],
            current:1,
            taxArr:[],
            stfgBool:true,
            addBool:false, //新增,为true时--禁止
            editBool:false, //编辑,为true时--禁止
            delBool:false, //删除 ,为true时--禁止
            cfmBool:false, //审核 ,为true时--禁止
            cancelBool:false, //作废 ,为true时--禁止
            pageList: [ {
                value: 50,
                label: '50'
                }, {
                value: 100,
                label: '100'
            }],
        }
    },
    mounted () { 
        //操作符
        getTabColOrData(this.v_url,'v_sys_base','PARENTNO','15995').then((res) => {
            this.operArr =res.result
        })
    },
    computed: {
        editHeight: function() {
            return (window.innerHeight - 300) + 'px';
        }, 
        tabHeight: function() {
            return (window.innerHeight - 470) + 'px';
        }, 
    },
    components: {

    },
    created () {       
        if (this.v_username){ 
            //查询数据
            this.getOrdList(' and stfg=\'Y\'')
            this.getTabField() //表列字段
    
        }else{
            let routeUrl = this.$router.resolve({
                path: '/login',
                query: {},
            });
            window.open(routeUrl.href, '_self');
        }
    },
    watch: {
 
    },
    methods: {
        selSure(){
            let data_=[]
            for(let k=0;k<this.dtlData.length;k++){
                if(this.dtlData[k].SEL==='Y'){
                    data_.push(this.dtlData[k])
                }
            }
            this.$emit('child-sure',data_)
        },
 
        //产品选择
        matChoose(){
            this.prodWin=true
        },
        matOk(matno,matnm,matdesc,unit,prc){
            this.dtlRow['MATNO']=matno
            this.dtlRow['MATNM']=matnm
            this.dtlRow['MATDESC']=matdesc
            this.dtlRow['UNITNM']=unit
            this.prodWin=false
        },
        //业务员选择
        empChoose(){
            this.empWin=true
        },
        empOk(idseq,val){
            this.mainRow['STAFF']=idseq
            this.mainRow['STAFFNM']=val
            this.empWin=false
        },
        //客户选择
        orgChoose(){
            this.clntWin=true
        },
        supOk(idseq,val){
            this.mainRow['SUPNO']=idseq
            this.mainRow['SUPNM']=val
            this.clntWin=false
        },
        //表行点击事件
        rowClick(row){
 
            this.getDtlData(row.IDSEQ)
        },
        perSure(){
            if (!this.dtlRow['MATNO']){
                this.promtWin=true
                this.prompt='产品编码不能为空'
            }else{
                this.perWin =false
                if (this.perFlag==='edit' ){ //编辑时要替换数组记录
                    this.dtlData.splice(this.rowIndex,1,this.dtlRow)
                }else{
                    this.dtlData.push(this.dtlRow)
                }
            }
        },
        perClick(row){
            
        },
        perEdit(row ,index){
            this.dtlRow=JSON.parse(JSON.stringify(row))
            this.perWin=true
            this.perFlag='edit'
            this.rowIndex=index
        } ,
        perDel(row,index){
            this.$confirm('你确定要删除此行记录吗','提示',{
                confirmButtonText: '确定',
                cancelButtonText:'取消',
                customClass:'messageBox',
                showClose:false,
                closeOnClickModal:false,
                closeOnPressEscape:false,
                type:'info',
            }).then(()=>{
                this.dtlData.splice(index,1)
                this.delArr.push(row)
            }).catch(()=>{})
        },
        perAdd(){
            this.dtlRow={'DIST':100}
            this.perFlag='create'
            this.perWin=true
        },
 
        //订单明细
        getOrdList(cond){
            this.v_loading=true
            //获取所有产品记录且初始化分页记录         
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getBaseData',
                data: {p_key:'IDTY', p_value:'POIN',p_key2:'corpid', p_value2:this.v_corpid,p_cond:cond,p_table:'V_IC_STK_QRY'},
            }).then(res=>{ 
                if (res.code==='200'){
                    this.allData =res.result
                    this.initPage() 
                    if (res.result.length>0){
                        this.getDtlData(res.result[0].IDSEQ)
                        this.$refs['tabref'].setCurrentRow(res.result[0])
                    }else{
                        this.dtlData=[]
                    }
                    this.v_loading=false
                }else{
                    this.promtWin=true
                    this.prompt=res.result
                    this.v_loading=false
                }
            }) 
        },
        //查询明细数据
        getDtlData(idseq){
            this.v_loading2 =true
            getTabColOrData(this.v_url,'v_IC_STKdtl','idseq',idseq).then((res) => {
                this.dtlData=[]
                this.dtlData =res.result  
                this.$nextTick(()=>{
                    this.$refs['refdtl'].doLayout()
                    this.v_loading2 =false
                })
            })
        },
        //跳至页面
        goNext(){
            if (this.goPage){
                this.changePage(this.goPage)
                this.current =Number(this.goPage)
            }else{
                this.promtWin=true
                this.prompt='请输入跳至页数'
            }
        },
        //初始化查询页条数
        initPage(){
            //产品明细
            this.dataCount =this.allData.length //总条数
            // 初始化显示，小于每页显示条数，全显，大于每页显示条数，取前每页条数显示
            if (this.allData.length < this.rowSize){
                this.tabData = this.allData          
            }else{
                this.tabData =this.allData.slice(0,this.rowSize) //返回选定元素的子数组，不包含结尾元素
            }
        },
        //表格页面导航
        changePage(index){
            var _start = ( index - 1 ) * this.rowSize;
            var _end = index * this.rowSize;
            this.tabData = this.allData.slice(_start,_end);
        },
 
        getRowKey(row){
            return row.IDSEQ
        },
        //查询
        qryTabData(){
            let cond_=''
            if (this.selparam){ //列1
                if (this.oper==='like'){
                    cond_=cond_+' and '+this.selparam+' like \'%' + this.txtparam+'%\''
                }else{
                    cond_=cond_+' and '+this.selparam +this.oper+'\''+this.txtparam+'\''
                }
            }

            this.getOrdList( ' and stfg=\'Y\''+ cond_)

        },
        //新增客户
        addRec(){
            this.drawer =true
            this.stfgCss='icon-weishenhe3'
            this.mainRow={ORDDTTM:getDate('day')}
            this.saveFlag=false
            this.dtlData=[]
        },
        //状态查询
        stfgChange(){
            this.qryTabData()
        },
 
        //获取表列字段
        getTabField(){
            let vm =this
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','112','lstseq','4','','',' order by sortby,lstseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.tabArr.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        edcss:res.result[k].EDCSS,
                        disabled:res.result[k].DISABLED,
                        dotnum:res.result[k].DOTNUM,
                        sortable:res.result[k].SORTABLE, 
                    })
                }
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','112','lstseq','2','','',' order by sortby,itmseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.dtlCol.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        edcss:res.result[k].EDCSS,
                        disabled:res.result[k].DISABLED,
                        dotnum:res.result[k].DOTNUM,
                        sortable:res.result[k].SORTABLE, 
                    })
                }
            })
        }
    }
}
</script>
<style scoped lang="less">
    .el-aside {
        height: calc(100vh - 100px);// vh就是当前屏幕可见高度的1%   只用设置左侧 aside 高度
    }
    .oneMenu{
        line-height:35px;
        text-align:left;
        padding-left:35px;
        font-size:14px;
        color:white;
        background-color: #409eff;
    }
    .oneMenu:hover{
        cursor: pointer;
        color:#f4f6f8;
    }
    .twoMenu{
        display:flex;
        flex-direction:column;
        line-height:40px;
        background:white;
        padding-left:35px;
 
    }
    .twoMenu:hover{
        cursor: pointer;
        color:#409EFF;
    }
    .top{
        padding: 10px;
        background: rgba(0, 153, 229);
        color: #fff;
        text-align: center;
        font-size:10px;
        border-radius: 2px;
    }  
    .el-header  {
        background-color: #fff;
        color: #409EFF;
        text-align: center;
        line-height: 60px;
        width:100%;
    }
  .el-main {
    background-color: #fff;
    color: rgb(207, 206, 206);
    text-align: center;
    height:100%;
  }
 .pub_dialog {
        display: flex;
        justify-content: center;
        align-items: Center;
        overflow: hidden;
        .el-dialog {
            margin: 1px auto !important;
            height: 90%;
            overflow: hidden;
            .el-dialog__body {
                position: absolute;
                left: 0;
                top: 54px;
                bottom: 0;
                right: 0;
                padding: 0;
                z-index: 1;
                overflow: hidden;
                overflow-y: auto;
            }
        }
    }
    .item-width  {
        width: 48%;
        color:#409EFF;
    }
    .active { 
        color:#D200D2; 
    } 
    .wraper{
        width:1250px;
        margin:1px auto;
    }
</style>
<style lang="less">
    .custom-table-border .el-table__body td, .custom-table-border .el-table__header th {
        border-color: rgb(184, 181, 181);
        border-width: 1px;
    }
    .el-table {
        th {
            padding: 0 ;
        }
        thead{
            height: 15px !important;
            color:rgb(128,128, 128);
            font-size:12px;
        }
        td {
            padding: 5px ;
            font-size:11px;
        }   
    }
    .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after{
        border-color :#3d77eb
    }
    .el-checkbox__input.is-disabled+span.el-checkbox__label{
        color:#3d77eb
    }
    .el-dialog__body{
        padding: 10px;
    }
    .el-dialog__header{
        padding: 0px;
    }
    .el-dialog__footer{
        padding: 5px;
        border-top:1px solid #ccc;
    } 
    .el-dialog__headerbtn{font-size: 20px; background:white;top:5px !important;}
    .messageBox .el-message-box__content{
        border-top: 1px solid #EBEEF5;
        height: 50px;
    }
    .el-message-box__message p{
        line-height: 30px;
    }
    .messageBox .el-message-box__btns{
        padding: 20px 15px 0;
    }
    .messageBox .el-message-box__header{
        background:#409eff;
    }
    .messageBox .el-message-box__title{
        color:white ;
        font-size:14px;
    }
</style>
 